<template>
	<component
		:is="setup.ui.onLayoutNoAside ? 'o-card' : 'div'"
		v-if="setup.dataLoaded"
		class="dashboard-tempworker-calendar"
		:class="{ 'dashboard-tempworker-calendar--card': !setup.ui.onLayoutNavBottom }">
		<div class="dashboard-tempworker-calendar__disponibility">
			<div class="dashboard-tempworker-calendar__table">
				<o-date-table
					:ref="setup._calendar"
					v-model="setup.selectedDay"
					class="calendar"
					:date-selected="setup.selectedDay"
					:periods="setup.periods"
					disable-month-and-year
					:can-go-prev-month="setup.canGoPrevMonth"
					:min-date="setup.minDate"
					type="date"/>

				<o-label v-if="setup.isMissionDay">
					Vous êtes en mission
				</o-label>
			</div>


			<div
				v-if="!setup.isAvailable"
				class="dashboard-tempworker-calendar__description">
				<dashboard-temp-worker-availabilities
					v-if="setup.isSpecificDay !== undefined"
					:value="setup.isSpecificDay"
					:period="setup.periodSelected"
					type="specific"/>
				<dashboard-temp-worker-availabilities
					v-if="setup.isUnavailableDay"
					:period="setup.isUnavailableDay"
					type="unavailabilities"/>
				<dashboard-temp-worker-mission
					v-if="setup.isMissionDay"
					:mission="setup.isMissionDay"/>
			</div>
			<div
				v-if="setup.isAvailable"
				class="dashboard-tempworker-calendar__actions">
				<o-button
					v-if="setup.isCurrentOrUpcoming && setup.isAvailable"
					prefix-font-icon="icon-interface-add-circle"
					color="info"
					outline
					@click="setup.verifyAndOpenAsideSpecAvailPeriod()">
					Ajouter une disponibilité particulière
				</o-button>

				<o-button
					v-if="setup.isCurrentOrUpcoming && setup.isAvailable"
					prefix-font-icon="icon-interface-add-circle"
					color="warning"
					outline
					@click="setup.showUnavailabilityAsideNew()">
					Ajouter une indisponibilité
				</o-button>
			</div>
		</div>
	</component>
</template>

<script setup lang="ts">
import DashboardTempWorkerCalendarSetupService from '@/setup/dashboard/temp-worker/DashboardTempWorkerCalendarSetupService';
import DashboardTempWorkerAvailabilities from '@/components/dashboard/temp-worker/DashboardTempWorkerAvailabilities.vue';
import DashboardTempWorkerMission from '@/components/dashboard/temp-worker/DashboardTempWorkerMission.vue';
const setup = new DashboardTempWorkerCalendarSetupService();
</script>

<style scoped lang="less">
@import '@/styles/variables';

.dashboard-tempworker-calendar {

	:deep(.orion-date-table) {
		background-color: unset;
		transform: scale(0.90);
		padding: 0;
	}

	&__disponibility {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		gap: 2rem;

		@media @tabletLandscape, @phone {
			flex-direction: column;
			gap: 0.5rem;
			align-items: center;
		}
	}

	&__description {
		width: 100%;
	}

	&__actions {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		margin-top: 1rem;
	}

	.orion-label {
		justify-content: center;
		display: flex;
		align-items: center;
		height: 2rem;
	}
}
</style>
